import { useState } from 'react'

const EmailSender = () => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [succeeded, setSucceeded] = useState(false)
    const [error, setError] = useState(null)

    // The reply-to email address that will be used for all emails
    const replyToEmail = 'info@techdigitsolutions.com'

    const sendEmail = async (formData, emailSubject, customTemplate = null) => {
        setIsSubmitting(true)
        setError(null)

        try {
            const response = await fetch('https://email-nodejs-fawn.vercel.app/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    emailConfig: {
                        host: 'mail.techdigitsolutions.com',
                        port: 465,
                        user: 'info@techdigitsolutions.com',
                        pass: 'kCRy3{U9t2p-0-@p',
                        from: 'TechDigit Solutions <info@techdigitsolutions.com>',
                    },
                    emailData: {
                        to: 'info@techdigitsolutions.com',
                        from: {
                            name: 'TechDigit Solutions',
                            email: 'info@techdigitsolutions.com',
                        },
                        sender: {
                            name: 'TechDigit Solutions',
                            email: 'info@techdigitsolutions.com',
                        },
                        replyTo: replyToEmail,
                        headers: {
                            'Reply-To': replyToEmail,
                            'Return-Path': replyToEmail,
                            From: 'TechDigit Solutions <info@techdigitsolutions.com>',
                        },
                        subject: emailSubject,
                        text: generateTextContent(formData, replyToEmail),
                        html: customTemplate || generateHtmlContent(formData, replyToEmail),
                    },
                }),
            })

            if (response.ok) {
                setSucceeded(true)
                return true
            } else {
                const errorData = await response.json()
                setError(errorData.message || 'Failed to submit. Please try again.')
                return false
            }
        } catch (err) {
            setError('Network error. Please try again later.')
            return false
        } finally {
            setIsSubmitting(false)
        }
    }

    const generateTextContent = (formData, replyEmail) => {
        let content = Object.entries(formData)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n')

        // Add a footer with the reply information
        content += `\n\n---\nPlease reply to: ${replyEmail}`
        return content
    }

    const generateHtmlContent = (formData, replyEmail) => {
        return `
      <h2>New Form Submission</h2>
      ${Object.entries(formData)
          .map(([key, value]) => `<p><strong>${key}:</strong> ${value}</p>`)
          .join('')}
      <hr />
      <p style="font-size: 12px; color: #666;">If you'd like to respond to this email, please reply to: <a href="mailto:${replyEmail}">${replyEmail}</a></p>
    `
    }

    return {
        isSubmitting,
        succeeded,
        error,
        sendEmail,
        setSucceeded,
        setError,
    }
}

export default EmailSender
